module.exports = __webpack_public_path__ + "static/media/field-development.c2fe00b2.svg";